import type { ShipmentOptionDto } from '~/common/model/capabilities'
import { useDataAsyncCall } from '~/api/admin-api'

export const useShipmentOptions = (businessUnit: string | undefined) => {
  const [shipmentOptions, { isLoading }] = useDataAsyncCall<ShipmentOptionDto[]>(
    `shipment-options/${businessUnit}?whitelistRequired=true`
  )
  return { shipmentOptions: shipmentOptions ?? [], isLoading }
}
